import adyenService from './rbmc.payment-adyen-service';

const paymentPage = {
    showNoPaymentSelectedError: $('#noPaymentSelectedError'),

    reviewPaymentDetails() {
        if (this.isNoPaymentError()) {
            adyenService.reviewPayment();
        }
    },

    submitPaymentDetails() {
        adyenService.placeOrder(undefined);
    },

    isNoPaymentError() {
        if (!adyenService.paymentSelected) {
            this.showNoPaymentSelectedError.removeClass('d-none')
            return false;
        } else {
            this.showNoPaymentSelectedError.addClass('d-none')
            return true;
        }
    },

    bindHandlers() {
        $('#submitPayment').on('click', (evt) => {
            this.reviewPaymentDetails();
        });
    }
};

$(() => {
    if ($('#checkout-payment-page').length) {
        paymentPage.bindHandlers();
        adyenService.cacheSelectors();
        adyenService.initDropIn();
    }
});

export default paymentPage
